const TitleSecondary = ({text , className}) => {
  return (
    <h2 className={`TitleSecondary ${className}`}>{text}</h2>
  )
}

export { TitleSecondary }